import { useState, useEffect, useRef } from "react";

function FlipDigit({ char }) {
  const [displayed, setDisplayed] = useState(char);
  const [animating, setAnimating] = useState(false);
  const prev = useRef(char);

  useEffect(() => {
    if (char === prev.current) return;
    setAnimating(true);
    // Swap the character at the midpoint (when tile is "folded" flat)
    const swap = setTimeout(() => {
      setDisplayed(char);
      prev.current = char;
    }, 130);
    const done = setTimeout(() => setAnimating(false), 280);
    return () => { clearTimeout(swap); clearTimeout(done); };
  }, [char]);

  if (char === ",") return <span className="flip-comma">,</span>;

  return (
    <span className={`flip-digit-tile ${animating ? "flip-animating" : ""}`}>
      {displayed}
    </span>
  );
}

export default function FlipCounter({ target = 0, delay = 0 }) {
  const startVal = Math.max(0, target - 4);
  const [value, setValue] = useState(startVal);
  const hasAnimated = useRef(false);
  const currentRef = useRef(startVal);

  useEffect(() => {
    if (target === 0 || hasAnimated.current) {
      // If value grew from polling, jump directly (no re-animation)
      if (target > currentRef.current) {
        currentRef.current = target;
        setValue(target);
      }
      return;
    }

    hasAnimated.current = true;
    const start = Math.max(0, target - 4);
    currentRef.current = start;
    setValue(start);

    const tick = () => {
      if (currentRef.current >= target) return;
      currentRef.current += 1;
      setValue(currentRef.current);
      if (currentRef.current < target) setTimeout(tick, 340);
    };

    setTimeout(tick, delay);
  }, [target, delay]);

  const chars = value.toLocaleString().split("");
  const len = chars.length;

  return (
    <span className="inline-flex items-center gap-px">
      {chars.map((ch, i) => (
        <FlipDigit key={`${i}-${len}`} char={ch} />
      ))}
    </span>
  );
}
